import React from 'react';
import * as R from 'ramda';
import {SystemConfigCtx} from '@/contexts';
import useAPI from '@/hooks/useAPI';
import * as api from '@/apis/index';

const systemConfig = {
  feature: {
    external: process.env.REACT_APP_ENABLE_EXTERNAL,
    internal: process.env.REACT_APP_ENABLE_INTERNAL,
  },
};

const SystemConfigProvider = ({children}) => {
  const {result} = useAPI(api.siteInfo);
  const siteInfo = R.propOr({}, 'data', result);

  return (
    <SystemConfigCtx.Provider value={{systemConfig, ...siteInfo}}>
      {children}
    </SystemConfigCtx.Provider>
  );
};

export default SystemConfigProvider;
